module.exports = __webpack_public_path__ + "static/media/cloud_uploader_icon.23fd8e56.svg";